export class PayerLinkageCustomer {
    ID?: number;
    RequestID?: number;
    CustomerNumber: string;
    LinkToSelf: boolean;
}

export default PayerLinkageCustomer;